module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-8.svg?937ed75177e0cf6f47ad3cf0f026c6c5";